import LiveUpdatesModal from './LiveUpdatesModal'

export default LiveUpdatesModal
